import { Identifiable } from "./identifiable";
import { List, list } from "./list";
import { Zone, zone } from "./zone";
import { projectStatus, ProjectStatus } from "./projectStatus";
import { id } from "./id";
import { Tag } from "./tag";
import { Resource } from "./resource";

type Project = {
  uuid: string;
  name: string;
  code: string;
  description: string;
  zone: Identifiable<Zone>;
  status: Identifiable<ProjectStatus>;
  tags: Tag[];
  createdDate: string;
  rootList: Identifiable<List>;
  finalPlannedValueOfProject: number;
  proportionOfAccomplishedWork: number;
  proportionOfDelayedWork: number;
  proportionOfOpenedWork: number;
  totalOfRemainingTimeInProject: number;
  totalOfTimesSpentInProject: number;
  totalSumOfTimeAllocatedOnTheProject: number;
  averageOfConsistencyOfStrategicAxes: number;
  trackingAcquiredValue: number;
  allocatedBudget: number;
  allocatedExpensesBudget: number;
  allocatedResourcesBudget: number;
  realMarginBudget: number;
  plannedMarginBudget: number;
  projectManagers: Identifiable<Resource>[];
  trackingRealCost: number;
  integratedAt?: string;
  isTemplate?: boolean;
  attributes: { [key: string]: string };
  data: { [key: string]: string };
  memberDeactivated: boolean;
  timeZone?: string;
};

const project: Project = {
  uuid: id,
  name: "",
  description: "",
  code: "",
  createdDate: "",
  status: { ...projectStatus, uuid: id },
  tags: [],
  zone: { ...zone, uuid: id },
  rootList: { ...list, uuid: id },
  finalPlannedValueOfProject: 0,
  proportionOfAccomplishedWork: 0,
  proportionOfDelayedWork: 0,
  proportionOfOpenedWork: 0,
  totalOfRemainingTimeInProject: 0,
  totalOfTimesSpentInProject: 0,
  totalSumOfTimeAllocatedOnTheProject: 0,
  averageOfConsistencyOfStrategicAxes: 0,
  allocatedBudget: 0,
  allocatedExpensesBudget: 0,
  allocatedResourcesBudget: 0,
  plannedMarginBudget: 0,
  realMarginBudget: 0,
  projectManagers: [],
  trackingAcquiredValue: 0,
  trackingRealCost: 0,
  attributes: {},
  data: {},
  memberDeactivated: false,
};

export type { Project };

export { project };
